import { Report } from "pmt-types/src/models/Report.ts";

import {
  ReportFormat,
  ReportFormatDisplayName,
  ReportFormatEnum,
} from "pmt-types/src/enums/ReportFormat.ts";
import {
  ReportTypeDisplayName,
  ReportTypeEnum,
} from "pmt-types/src/enums/ReportType.ts";
import { useState } from "react";
import SearchPage from "../../components/search/searchPage.tsx";
import { useMutationGenerateReportLink } from "../../hooks/mutations/useMutationGenerateReportLink.ts";
import cx from "../../utils/cx.ts";
import formatDateString from "../../utils/formatDateString.ts";
import { Maybe } from "../../utils/types/maybe.ts";

export default function ReportsList() {
  const { mutate: generatePdfLink, isLoading: isPdfLinkLoading } =
    useMutationGenerateReportLink();
  const [loadingReport, setLoadingReport] = useState<Maybe<Report>>(null);

  return (
    <SearchPage<Report>
      route="reports"
      allowEntityCreate={true}
      createButtonLabel="New Report"
      showSearchBar={true}
      resultsColumnDef={[
        {
          accessorKey: "name",
          id: "name",
          cell: (info) => info.getValue(),
          header: "Report",
          minSize: 400,
        },
        {
          accessorKey: "reportType",
          id: "reportType",
          cell: (info) =>
            ReportTypeDisplayName[info.getValue() as ReportTypeEnum],
          header: "Type",
          minSize: 100,
        },
        {
          accessorKey: "reportFormat",
          id: "reportFormat",
          cell: (info) =>
            ReportFormatDisplayName[
              (info.getValue() as ReportFormatEnum) ?? ReportFormat.enum.Pdf
            ],
          header: "Format",
          minSize: 100,
        },
        {
          accessorKey: "createdDate",
          id: "createdDate",
          cell: (info) => formatDateString(info.getValue() as string),
          header: "Report Date",
        },
        {
          id: "view",
          cell: (info) => (
            <a
              onClick={() => {
                if (isPdfLinkLoading) {
                  return false;
                }

                const report = info.row.original as Report;

                setLoadingReport(report);

                generatePdfLink(report, {
                  onSuccess: (data) => {
                    window.open(data.url, "_blank", "noreferrer");
                  },
                  onError: (error) =>
                    console.error("Error generating pdf link", error),
                });
              }}
              className={cx(
                isPdfLinkLoading && loadingReport?.id == info.row.original.id
                  ? "text-slate-600 hover:text-slate-900"
                  : "text-sky-600 hover:text-sky-900",
                "hover:cursor-pointer",
              )}
            >
              {(info.row.original as Report).reportFormat ===
              ReportFormat.enum.Excel
                ? "Download"
                : "View"}
              <span className="sr-only">, {info.row.index}</span>
            </a>
          ),
          header: "",
          maxSize: 100,
        },
      ]}
    />
  );
}
